import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colourMasterLighter } from 'Styles/colors.css';
import { mouseScroll } from 'Shared/assets/images/';
import { LoadingSpinner } from 'PreviewComponents/ResizableContainer/LoadingSpinner';
import { getDeviceDimensions } from 'PreviewSelectors';
import {
  colorBorder,
  colourMasterLightest,
} from 'Styles/colors.css';

import {
  MOBILE_DEVICE_TOOLBAR_HEIGHT,
} from 'PreviewConstants/';

import {
  TOPBAR_HEIGHT,
} from 'SharedConstants/';

const DeviceContainer = styled.div`
  position: absolute;
  left: 50%;
  top: calc(50% + ${TOPBAR_HEIGHT}px);
  width: ${props => props.dimensions.width}px;
  height: ${props => props.dimensions.height}px;
  marginLeft: -${props => props.dimensions.width / 2}px;
  marginTop: -${props => (props.dimensions.height / 2) + (TOPBAR_HEIGHT / 2)}px;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`;

const ToolbarContainer = styled.div`
    position: relative;
    width: 100%;
    height: ${MOBILE_DEVICE_TOOLBAR_HEIGHT}px;
    border-bottom: 1px solid ${colorBorder};
    color: #aaa;
    background: ${colourMasterLightest};
    z-index: 10000;
`;

const AppToolbarContainer = styled.div`
    width: 100%;
    height: ${props => props.deviceHeader}px;
    background-image: url(${props => props.background});
    background-size: 100% auto;
`;

const AdName = styled.div`
    width: 100%;
    line-height: ${MOBILE_DEVICE_TOOLBAR_HEIGHT}px;
    position: absolute;
    text-align: center;
`;

const ToolbarIcon = styled.i`
    line-height: ${MOBILE_DEVICE_TOOLBAR_HEIGHT}px;
    float: right;
    margin-right: 20px;
    font-size: 16px;
`;

export const MobileDeviceContainer = ({ children, device, isDevice, inApp, deviceHeader, background }) => {
  const deviceSize = 'medium';
  const deviceDimensions = getDeviceDimensions(device, deviceSize);
  return (
    <DeviceContainer
      dimensions={deviceDimensions}
      className="preview-device-container"
    >
      {inApp ?
        <AppToolbarContainer
          deviceHeader={deviceHeader}
          background={background}
        /> :
        <ToolbarContainer>
          <ToolbarIcon className="pg-battery_empty" />
          <ToolbarIcon className="fa fa-wifi" />
        </ToolbarContainer>
      }
      {children}
    </DeviceContainer>
  );
};

MobileDeviceContainer.propTypes = {
  children: PropTypes.element.isRequired,
  device: PropTypes.string,
  isDevice: PropTypes.bool,
};

MobileDeviceContainer.defaultProps = {
  device: 'mobile',
  isDevice: false,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/MobileDeviceContainer/MobileDeviceContainer.jsx